import { IMyOwnTractorDetail } from '../../../interfaces/OwnTractor.interfaces';
import { customAxios } from '../../common/customAxios';

export const myOwnTractorsApiUrl = '/users-own-tractors/mine';

interface IGetMyOwnTractorByIdParams {
  ownTractorId: string;
}

export const getMyOwnTractorById = ({ ownTractorId }: IGetMyOwnTractorByIdParams): Promise<IMyOwnTractorDetail> => {
  return customAxios.get(`${myOwnTractorsApiUrl}/${ownTractorId}`);
};
